module.exports = __webpack_public_path__ + "img/prepinterview.aacd9fe9.svg";